import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";
import PreStartQuestionView from "../../JobShiftPreStart/sections/PreStartQuestionView";
import { isReadinessQuestionActive } from "./readinessQuestionsFormUtils";
const getHeadingContent = (readinessData = {}) => {
  const contents = readinessData.heading_contents && typeof readinessData.heading_contents === "object"
    ? readinessData.heading_contents
    : {};
  return typeof contents.rescue_readiness_checklist_heading === "string"
    ? contents.rescue_readiness_checklist_heading
    : "";
};

const READINESS_HEADING_KEY = "readiness_checklist_heading";

const EditHeadingButton = ({ onClick, title, disabled }) => (
  <button
    type="button"
    className={`${styles.PreviewHeadingEditButton} ${disabled ? styles.PreviewHeadingEditButtonDisabled : ""}`.trim()}
    onClick={onClick}
    title={title}
    aria-label={title}
    disabled={disabled}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className={styles.EditIcon} style={{ height: "14px" }}>
      <path fill="currentColor" d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" />
    </svg>
  </button>
);

export default function ReadinessQuestionsBlock({ questions, formChange, readinessData, filesPath, onEditHeading, disableHeadingEdit = false, onOpenPhotoPreview }) {
  const questionsHeading = getHeadingContent(readinessData) || null;
  const activeQuestions = Array.isArray(questions)
    ? questions.filter((questionEntry) => questionEntry && isReadinessQuestionActive(questionEntry.question))
    : [];

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.readinessSectionNum || ""}`.trim()}>2</span>
        Rescue Readiness Questions
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={styles.PreviewEditableHeading}>
          <div className={`${styles.PreviewRichText} preview-swms-v3-authorization-rich-text`} dangerouslySetInnerHTML={{ __html: questionsHeading || "" }}></div>
          <EditHeadingButton onClick={onEditHeading} title="Edit Readiness Questions Heading" disabled={disableHeadingEdit} />
        </div>
        <table className={styles.PreviewTable}>
          <tbody>
            {activeQuestions.length > 0 ? activeQuestions.map((questionEntry, index) => (
              <PreStartQuestionView
                key={questionEntry && questionEntry.question && questionEntry.question.id ? questionEntry.question.id : index}
                number={index + 1}
                question={questionEntry && questionEntry.question ? questionEntry.question : null}
                supervisorParticipant={questionEntry && questionEntry.supervisorParticipant ? questionEntry.supervisorParticipant : null}
                supervisorAnswer={questionEntry && questionEntry.supervisorAnswer ? questionEntry.supervisorAnswer : null}
                supervisorFieldName={questionEntry && questionEntry.supervisorFieldName ? questionEntry.supervisorFieldName : null}
                supervisorCommentFieldName={questionEntry && questionEntry.supervisorCommentFieldName ? questionEntry.supervisorCommentFieldName : null}
                supervisorFlaggedResponseFieldName={questionEntry && questionEntry.supervisorFlaggedResponseFieldName ? questionEntry.supervisorFlaggedResponseFieldName : null}
                workerAnswers={questionEntry && Array.isArray(questionEntry.workerAnswers) ? questionEntry.workerAnswers : []}
                formChange={formChange}
                filesPath={filesPath}
                onOpenPhotoPreview={onOpenPhotoPreview}
              />
            )) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
}
